import { render, staticRenderFns } from "./GlobalAiSidebar.vue?vue&type=template&id=53069219&scoped=true"
import script from "./GlobalAiSidebar.vue?vue&type=script&lang=js"
export * from "./GlobalAiSidebar.vue?vue&type=script&lang=js"
import style0 from "./GlobalAiSidebar.vue?vue&type=style&index=0&id=53069219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53069219",
  null
  
)

export default component.exports